import { apiInterfaceForJson } from '../common/apiManager';

export const fetchMedications = () => {
    return apiInterfaceForJson('/medication/v1/', 'GET');
};

export const getMedicationDataById = (medicationId) => {
    return apiInterfaceForJson('/medication/v1/' + medicationId, 'GET');
};

export const createMedication = (medicationDetails) => {
    return apiInterfaceForJson('/medication/v1/', 'POST', medicationDetails);
};

export const updateMedication = (medicationDetails) => {
    return apiInterfaceForJson('/medication/v1/', 'PUT', medicationDetails);
};

export const deleteMedication = (medicationDetails) => {
    return apiInterfaceForJson('/medication/v1/delete', 'POST', medicationDetails);
};
